<template>
  <form class="form-horizontal form" role="form">
    <div class="form-body">
      <div class="form-group">
        <label class="col-sm-3 control-label">分组</label>
        <div class="col-sm-8">
          <select class="form-control" v-model="gid">
            <option value="0">未分组</option>
            <template v-for="g in groups">
              <option :value="g.objectId" :key="g">{{ g.title }}</option>
            </template>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3"
          >图片
          <span class="required"> * </span>
        </label>
        <div class="col-sm-8">
          <c-file-upload :config.sync="cover"></c-file-upload>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">描述</label>
        <div class="col-sm-8">
          <!--<textarea class="form-control" rows="3"></textarea>-->
          <input class="form-control" type="text" v-model="title" />
        </div>
      </div>
    </div>
    <div class="form-actions">
      <div class="row">
        <div class="col-sm-offset-3 col-sm-8">
          <button type="button" class="btn green" @click="submit()">
            保存
          </button>
          <button
            type="button"
            class="btn grey-salsa btn-outline"
            @click="cancel()"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script type="text/javascript">
import $ from 'jquery'
import '../../assets/global/scripts/ajaxfileupload'

import { mapState, mapActions } from 'vuex'
import cFileUpload from '../../components/fileupload'

export default {
  data() {
    return {
      gid: localStorage.getItem('group') || 'ungroup',
      title: '',
      cover: {
        type: 'simple',
        name: 'file',
        fileName: null,
        file: null
      }
    }
  },
  components: {
    cFileUpload
  },
  computed: mapState(['groups']),
  methods: {
    ...mapActions([
      'toast',
      'showAlert',
      'showConfirm',
      'showLoading',
      'hideLoading'
    ]),
    submit() {
      let self = this
      this.showLoading('提交中，请稍后。。。')
      $.ajaxFileUpload({
        url: '/api/web/material/img/add',
        secureuri: false,
        fileElementId: $(self.cover.file),
        data: {
          title: self.title,
          gid: self.gid
        },
        dataType: 'string',
        success: function(data, status) {
          self.hideLoading()
          if (data.code == 200) {
            self.toast('恭喜您，添加成功！')
          } else {
            self.showAlert('操作失败，请稍后再试！')
          }

          self.$emit('image-create-cancel')
        },
        error: function(data, status, e) {
          self.hideLoading()
          self.showAlert('操作失败，请稍后再试！')
          self.$emit('image-create-cancel')
        }
      })
    },
    cancel() {
      this.$emit('image-create-cancel')
    }
  }
}
</script>
